if(typeof CarouselComponent !== 'function'){
  class CarouselComponent extends HTMLElement {
  
    constructor() {
      super();
      
      if(window.innerWidth <= 768) this.dataset.enable = true;
      if(this.dataset.enable != 'true') return;
      
      this.slider = this.querySelector('ul.carousel');
      this.sliderItems = this.slider.querySelectorAll('li:not(.hidden)') || [];
      this.sliderImages = this.slider.querySelectorAll('li:not(.hidden) img') || [];
      this.slideWidth = this.sliderItems[0].clientWidth;
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');
  
      if (!this.slider || !this.nextButton) return;

      const attrObserver = new MutationObserver((mutations) => {
        mutations.forEach(mu => {
          if (mu.type !== "attributes" && mu.attributeName !== "class") return;
          
          this.sliderItems = this.querySelectorAll('li:not(.hidden)') || [];
          this.slideWidth = this.sliderItems[0].clientWidth;
          this.sliderImages = this.slider.querySelectorAll('li:not(.hidden) img') || [];
          this.initializeButtons();
          this.initializeThumbnails();
        });
      });
      attrObserver.observe(this.slider, {attributes: true});

      this.initializeButtons();
      this.initializeThumbnails();
      
    }
    initializeButtons() {

      this.nextButton.addEventListener("click", (e) => {

        if((this.slider.scrollLeft + this.slideWidth) >= this.slider.scrollWidth){
          this.slider.scrollLeft = 0;
        }else{
          this.slider.scrollLeft += this.slideWidth;
        }

      });
       
      this.prevButton.addEventListener("click", (e) => {

        if(this.slider.scrollLeft == 0){
          this.slider.scrollLeft = this.slider.scrollWidth;
        }else{
          this.slider.scrollLeft -= this.slideWidth;
        }
      });
    }
    initializeThumbnails() {
      if(this.dataset.thumbnails != 'true') return;

      this.thumbnailsContainer = this.querySelector('carousel-thumbnails');
      if(!this.thumbnailsContainer) return;

      this.thumbnailsContainer.innerHTML = '';

      this.sliderImages.forEach((img, index) => {
        this.thumbnailsContainer.innerHTML = this.thumbnailsContainer.innerHTML + `<button type="button" name="slide-${index}" aria-label="Go to Slide ${index}"><img src="${img.getAttribute('src')}" /></button>`;
      });

      this.thumbnails = this.thumbnailsContainer.querySelectorAll('button') || [];

      this.thumbnails.forEach((button, index) => {
        button.addEventListener("click", () => {
          this.slider.scrollLeft = this.slideWidth*index;
        });
      })

    }

  }

  if(customElements.get('carousel-component') === undefined) 
    customElements.define('carousel-component', CarouselComponent);
  
}